import { Field, ImageField, Item } from '@sitecore-jss/sitecore-jss-nextjs';
import type { ComponentProps } from 'lib/component-props';

export type ZIPCodeSearchFields = {
  counties: string[];
  planType: Item | null;
  picture: ImageField;
  description: Field<string>;
  heading: Field<string>;
  headingStyle: Item;
  headingColor: Item;
  headingLevel: Item;
  zipCodeLabel: Field<string>;
  countyLabel: Field<string>;
  buttonLabel: Field<string>;
  planYears: string;
};

export type PlanTypeFields = {
  name: Field<string>;
  planOptionsListingPage: Item;
  planSearchPage: Item;
  planDetailPage: Item;
};

export type ZIPCodeSearchProps = ComponentProps & {
  id: string;
  fields: ZIPCodeSearchFields;
};
